<template>
  <div>
    <div class="spinner-backdrop" v-if="isLoading">
      <div class="spinner"></div>
    </div>
    <div class="container pt-4" v-if="!isLoading">
        <div class="d-flex align-items-center">
            <h2 class="m-0 mr-auto font-weight-light">My leads</h2>
        </div>
        <button @click="$router.push('add')" class="btn btn-outline-primary btn-block my-4">
          + Add Lead
        </button>
        <div class="mt-2 pb-4">
          <AppLeadCard :lead="lead" v-for="lead in this.opportunities" :key="lead.id"></AppLeadCard>
          <p v-if="this.opportunities.length === 0">You haven't submitted any opportunities yet.</p>
        </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import handleError from '../error-handler';

const AppLeadCard = () => import('../components/AppLeadCard.vue');

export default {
  name: 'home',
  components: {
    AppLeadCard,
  },
  data() {
    return {
      id: '',
      isLoading: true,
      settings: {
        logoUrl: '',
        companyName: '',
      },
      opportunities: [],
    };
  },
  computed: {

  },
  methods: {
    loadData() {
      axios.get([window.sm.url, `public/affiliates/${this.id}/opportunities`].join('/'))
        .then((response) => {
          this.opportunities = response.data;
          this.isLoading = false;
        }).catch((err) => {
        // eslint-disable-next-line
        alert('Unable to find your affiliate settings.  Please contact your affiliate sponsor.');
          handleError(err);
        });
    },
  },
  mounted() {
    const { id } = this.$route.params;
    this.id = id;

    this.loadData();
  },
};
</script>
